import clsx from "clsx"
import { Button } from "./Button"
import { LeftArrow, RightArrow } from "../../icons/arrows/carouselArrows"

export const Pagination = ({currentPage,setCurrentPage,totalPages}) => {
    return (
        <div className="flex gap-2 pt-12 pb-10">
            <Button disabled={currentPage === 0} onClick={()=>{setCurrentPage(currentPage-1)}} className={'w-8 h-8 bg-white rounded-[4px] border border-[#E2E2E2] items-center justify-center flex disabled:bg-[#A5A5A5] disabled:text-white'}><LeftArrow className={'h-3 stroke-black'}/></Button>
            {
                Array.from({ length: totalPages }, (_, index) => <Button onClick={()=>{setCurrentPage(index)}} className={clsx('w-8 h-8 bg-white rounded-[4px] text-label border',currentPage === index ? 'border-[#D4002A] text-[#D4002A]':'border-[#E2E2E2] text-[#282828]')}>{index + 1}</Button>)
            }
            <Button disabled={currentPage === totalPages-1} onClick={()=>{setCurrentPage(currentPage+1)}} className={'w-8 h-8 bg-white rounded-[4px] border border-[#E2E2E2] items-center justify-center flex disabled:bg-[#A5A5A5] disabled:text-white'}><RightArrow className={'h-3 stroke-black'}/></Button>
        </div>
    )
}